import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import { Field, reduxForm, propTypes as formPropTypes } from 'redux-form';
import cloneDeep from 'lodash/cloneDeep';
import numeral from 'numeral';
import ReduxFormField from '../common/forms/ReduxFormsField';
import CropperScaffold from '../common/forms/CropperScaffold';
import ReduxFormsImageCropper from '../common/forms/ReduxFormsImageCropper';
import CheckboxBoolean from '../common/forms/CheckboxBoolean';
import VideoUploader from '../common/components/VideoUploader';

const validate = values => {
  const errors = {};
  const { name, description, long_description, price } = values;

  if (!name || !name.trim()) {
    errors.name = ['Name is required'];
  } else if (name.trim().length > 255) {
    errors.name = ['Name cannot be longer than 255 characters'];
  }

  if (!description || !description.trim()) {
    errors.description = ['Description is required'];
  } else if (description.trim().length > 255) {
    errors.description = ['Description cannot be longer than 255 characters'];
  }

  if (!long_description || !long_description.trim()) {
    errors.long_description = ['About The Course is required'];
  }

  if (!Number.isInteger(price) || (price > 0 && price < 50)) {
    errors.price = ['Price must be at least $0.50'];
  }

  return errors;
};

class CourseEditForm extends Component {
  static propTypes = {
    ...formPropTypes,
    badges: PropTypes.instanceOf(List),
    clearOrigImage: PropTypes.bool.isRequired,
    clearIconImage: PropTypes.bool.isRequired,
    course: PropTypes.object.isRequired,
    previewUploading: PropTypes.bool.isRequired,
    previewUploadProgress: PropTypes.object.isRequired,
    onCancel: PropTypes.func.isRequired,
    onVideoUpload: PropTypes.func.isRequired,
    removeIcon: PropTypes.func.isRequired,
    removeImage: PropTypes.func.isRequired,
  };

  onSubmit = values => {
    const submitValues = cloneDeep(values);
    submitValues.description = submitValues.description.trim();
    submitValues.name = submitValues.name.trim();

    return this.props.onSubmit(submitValues);
  };

  renderBadgeOptionsItem(badge, isCurrentlyAssigned) {
    return (
      <option key={badge.get('id')} value={badge.get('id')}>
        {`${badge.get('name')}${isCurrentlyAssigned ? ' (Currently Assigned)' : ''}`}
      </option>
    );
  }

  renderBadgeOptions() {
    const { badges, course } = this.props;
    const options = [
      <option key="default" value="">
        None
      </option>,
    ];
    if (course.get('badge_id')) {
      options.unshift(this.renderBadgeOptionsItem(course.get('badge'), true));
    }
    badges.forEach(
      badge => course.get('badge_id') !== badge.get('id') && options.push(this.renderBadgeOptionsItem(badge))
    );
    return options;
  }

  render() {
    const {
      clearOrigImage,
      clearIconImage,
      course,
      handleSubmit,
      onCancel,
      onVideoUpload,
      previewUploading,
      previewUploadProgress,
      removeIcon,
      removeImage,
      submitting,
    } = this.props;

    return (
      <div className="admin-paper__edit-content">
        <form onSubmit={handleSubmit(this.onSubmit)}>
          <Field name="name" component={ReduxFormField} label="Course Name" required>
            <input type="text" />
          </Field>
          <Field name="description" component={ReduxFormField} label="Course Description" required>
            <input type="text" />
          </Field>
          <Field name="long_description" component={ReduxFormField} label="About The Course" required>
            <textarea />
          </Field>
          <Field
            name="price"
            component={ReduxFormField}
            label="Course Price"
            required={true}
            format={value => numeral(value / 100).format('$0,0.00')}
            parse={value => Number(value.replace(/\D/g, ''))}
          >
            <input type="text" />
          </Field>
          <Field name="badge_id" component={ReduxFormField} label="Badge" required>
            <select>{this.renderBadgeOptions()}</select>
          </Field>
          <VideoUploader
            onVideoUpload={onVideoUpload}
            uploading={previewUploading}
            uploadProgress={previewUploadProgress}
            video={course.get('video_id') ? course.get('video') : null}
            labelText="Course Preview Video"
          />
          {course && course.get('image_id') && !clearOrigImage ? (
            <CropperScaffold label="Course Image" required>
              <div className="original-image">
                <img alt="course logo" src={course.getIn(['image', 'location'])} />
              </div>
              <div className="cropper-scaffold__controls">
                <button type="button" className="button button--theme--outline" onClick={removeImage}>
                  Remove Image
                </button>
              </div>
            </CropperScaffold>
          ) : (
            <Field name="image" component={ReduxFormsImageCropper} label="Course Image" />
          )}
          {course && course.get('icon_id') && !clearIconImage ? (
            <CropperScaffold label="Course Icon" required>
              <div className="original-image">
                <img alt="course logo" src={course.getIn(['icon', 'location'])} />
              </div>
              <div className="cropper-scaffold__controls">
                <button type="button" className="button button--theme--outline" onClick={removeIcon}>
                  Remove Icon
                </button>
              </div>
            </CropperScaffold>
          ) : (
            <Field name="icon" component={ReduxFormsImageCropper} label="Course Icon" />
          )}
          <div className="admin-paper__edit-content__button-row">
            <div>
              <Field name="published" component={ReduxFormField} label="Course Published?" required={true}>
                <CheckboxBoolean />
              </Field>
            </div>
            <div>
              <button type="button" className="button button--theme--plain" onClick={onCancel} disabled={submitting}>
                Cancel
              </button>
              <button type="submit" className="button" disabled={submitting}>
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default reduxForm({
  form: 'courseEditForm',
  onSubmitFail: () => {
    window.scrollTo(0, 0);
  },
  validate,
})(CourseEditForm);



// WEBPACK FOOTER //
// ./src/courses/CourseEditForm.js